import { Station } from 'entities/stations';

import { MARKER_ALTITUDE_COORDS } from 'entities/map';

import { getMapStationMarkerType } from './getMapStationMarkerType';

// Here.com use getCoordinates only for markers station
// GoogleMap use getCoordinates for markers and clusters
export const getMapStationCoordinates = (
  { selectedStationCode }: { selectedStationCode?: Station['code'] } = {}
) => (
  { data }: { data: Station | { coordinates: { latitude: number; longitude: number; } } },
) => {
  let altitude = 0;

  if ('code' in data) {
    if (selectedStationCode === data.code) {
      altitude = MARKER_ALTITUDE_COORDS.cluster - 1
    } else {
      altitude = MARKER_ALTITUDE_COORDS[getMapStationMarkerType({ data })['markerType'] as keyof typeof MARKER_ALTITUDE_COORDS] || 1;
    }
  } else {
    altitude = MARKER_ALTITUDE_COORDS.cluster
  }

  return {
    latitude: data.coordinates.latitude,
    longitude: data.coordinates.longitude,
    altitude
  };
};
